import { useCookies } from 'react-cookie';
import { CookieSetOptions } from 'universal-cookie';
import { cookiesEnabled } from '../../common/helpers/environment';

export type Set = (value: any, ttl?: number) => void;

export const getCookieExpiration = (ttl: number) => new Date(Date.now() + ttl);

const truthyValues = ['true', '1'];
const falsyValues = ['false', '0'];

export const convertToBoolean = (value?: any) => {
    if (typeof value === 'string') {
        if (truthyValues.includes(value)) {
            return true;
        }

        if (falsyValues.includes(value)) {
            return false;
        }
    }

    return !!value;
};

const useBellaCookies = (name: string, shouldConvertToBoolean?: boolean) => {
    const [cookies, setCookie] = useCookies([name]);
    const rawValue = (cookies && cookies[name]) || undefined;
    const value = shouldConvertToBoolean ? convertToBoolean(rawValue) : rawValue;

    const set: Set = (value, ttl) => {
        if (cookiesEnabled) {
            const cookieData: CookieSetOptions = {
                path: '/',
            };

            if (ttl) {
                cookieData.expires = getCookieExpiration(ttl);
            }

            setCookie(name, value, cookieData);
        }
    };

    return [value, set, cookiesEnabled];
};

export const oneDayTTL = 86400000;
export const oneHourTTL = 3600000;

export default useBellaCookies;
